import { render } from "./subscriptionsList.vue?vue&type=template&id=c4b3643a&ts=true"
import script from "./subscriptionsList.vue?vue&type=script&lang=ts"
export * from "./subscriptionsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__